import { render, staticRenderFns } from "./voyage_mesh.vue?vue&type=template&id=16b8a224&"
import script from "./voyage_mesh.vue?vue&type=script&lang=js&"
export * from "./voyage_mesh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports